import React from 'react'
import { Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../constants/colors'
import { useTranslation } from '../hooks/useIntractionTranslate'

const BETA_TAG_FONT_SIZE_PX = 10 // well below the title it sits beside
const BETA_TAG_LETTER_SPACING_EM = 0.08

/** Marks a page that is still in beta, beside its title. */
export const BetaTag: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Typography
      component="span"
      sx={{
        px: 0.75,
        py: 0.2,
        flexShrink: 0,
        border: `1px solid ${INTERAX_COLORS.sun40}`,
        borderRadius: 1,
        color: INTERAX_COLORS.sun,
        backgroundColor: INTERAX_COLORS.sun10,
        fontSize: BETA_TAG_FONT_SIZE_PX,
        fontWeight: 800,
        lineHeight: 1.2,
        letterSpacing: `${BETA_TAG_LETTER_SPACING_EM}em`,
        textTransform: 'uppercase'
      }}
    >
      {t('common.beta')}
    </Typography>
  )
}
